import { Route, Routes } from "react-router-dom";
import Layout from "./components/common/Layout";
import RedirectRoute from "./components/common/RedirectRoute";
import Login from "./pages/account/Login";
import LoginNonMember from "./pages/account/LoginNonMember";
import TermsAndConditions from "./pages/account/TermsAndConditions";
import Signup from "./pages/account/Signup";
import FindPassword from "./pages/account/FindPassword";
import Main from "./pages/main/Main";
import MyPage from "./pages/account/MyPage";
import Orders from "./pages/order/Orders";
import UpdateOrder from "./pages/order/UpdateOrder";
import ResetPassword from "./pages/account/ResetPassword";
import NotFound from "./pages/NotFound";
import From from "./pages/order/From";
import To from "./pages/order/To";
import SelectCategory from "./pages/order/SelectCategory";
import SelectProduct from "./pages/order/SelectProduct";
import ProductDetail from "./pages/order/ProductDetail";
import NewOrder from "./pages/order/NewOrder";
import OrderCompleted from "./pages/order/OrderCompleted";
import OrderDetails from "./pages/order/OrderDetails";

const User = () => {
    return (
        <div>
            <Routes>
                <Route element={<Layout />}>
                    <Route path="/login" element={<Login />} />
                    <Route path="/login-non-member" element={<LoginNonMember />} />
                    <Route path="/find-password" element={<FindPassword />} />
                    <Route path="/signup" element={<Signup />} />
                    <Route path="/terms" element={<TermsAndConditions />} />
                    <Route path="/new-order" element={<NewOrder />}>
                        <Route path="from" element={<From />} index />
                        <Route path="select-category" element={<SelectCategory />} />
                        <Route path="select-product" element={<SelectProduct />} />
                        <Route path="product-detail/:idx" element={<ProductDetail />} />
                        <Route path="to" element={<To />} />
                    </Route>
                    <Route path="/order-completed" element={<OrderCompleted />} />
                    <Route path="/orders/non-member/:idx" element={<OrderDetails isMember={false} />} />
                    <Route path="/reset-password/:idx/:token" element={<ResetPassword />} />

                    <Route element={<RedirectRoute />}>
                        <Route path="/" element={<Main />} />
                        <Route path="/mypage" element={<MyPage />} />
                        <Route path="/orders" element={<Orders />} />
                        <Route path="/orders/:idx" element={<OrderDetails isMember={true} />} />
                        <Route path="/orders/:idx/update" element={<UpdateOrder />}>
                            <Route path="from" element={<From update />} index />
                            <Route path="select-category" element={<SelectCategory update />} />
                            <Route path="select-product" element={<SelectProduct update />} />
                            <Route path="product-detail/:idx" element={<ProductDetail update />} />
                            <Route path="to" element={<To update />} />
                        </Route>
                    </Route>

                    <Route path="/*" element={<NotFound />} />
                </Route>
            </Routes>
        </div>
    );
};

export default User;
